import React from 'react'
import { useLocation, useNavigate } from '@tanstack/react-router'

export interface SectionTabItem {
  label: string
  to: string
}

interface SectionTabsProps {
  items: SectionTabItem[]
}

export const SectionTabs: React.FC<SectionTabsProps> = ({ items }) => {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <div className="flex items-center gap-2">
      {items.map((item) => {
        const active =
          location.pathname === item.to || location.pathname.startsWith(item.to + '/')
        return (
          <button
            key={item.to}
            type="button"
            onClick={() => navigate({ to: item.to as never })}
            className={
              active
                ? 'admin-button admin-button-primary'
                : 'admin-button admin-button-secondary'
            }
          >
            {item.label}
          </button>
        )
      })}
    </div>
  )
}
